import * as zod from "zod";

export const addUserFormSchema = zod
  .object({
    email: zod
      .string()
      .min(1, { message: "Please enter your username" }),
    fullName: zod.string().min(1, { message: "Please enter your name" }),
    phoneNumber: zod.preprocess(
      (val) =>
        String(val)
          .slice(1)
          .replaceAll("_", "")
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll(" ", "")
          .trim(),
      zod.string().min(10)
    ),
    status: zod.any(),
    userType: zod.number().positive("Please select a user type"),
    merchant: zod.union([
      zod.number().positive("Please select a merchant"),
      zod.object({
        label: zod.string(),
        value: zod.number().positive(),
      }),
      zod.number(), // Eğer merchant değeri 0 olabilirse bu hattı ekleyin.
    ]),
    roleIds: zod.any(),
    isCepPOSActive: zod.boolean().default(false),
    parentUserId: zod.number().default(0),
    isGoldBindingActive: zod.boolean().default(false),
    isSoftPOSRefundAuthActive: zod.boolean().default(false),
  })
  .refine(data => {
    // Eğer userType member (1) değilse, merchant alanı zorunlu olmalıdır.
    if (data.userType !== 1 && (data.merchant === undefined || data.merchant === 0 || (typeof data.merchant === 'object' && data.merchant.value === 0))) {
      return false;
    }
    return true;
  }, {
    message: "Please select a merchant",
    path: ['merchant']
  })
  .refine(data => {
    // Burada roleIds objesinde en az bir keyin değeri true olmalıdır.
    if (data.roleIds) {
      return Object.values(data.roleIds).some(value => value);
    }
    return false;
  }, {
    message: "Please select at least one role",
    path: ['roleIds']
  });

export type UserAddFormValuesType = zod.infer<typeof addUserFormSchema>;
